import Vue from "vue";
import App from "./App.vue";
import GTM from "./plugins/GTM";
import steps from "../public/steps.json";
import createStore from "./store";

Vue.config.productionTip = false;

Vue.use(GTM);

window.calculatorApp = function(querySelector, jsonStepsData) {
  let vm = new Vue({
    store: createStore(),
    render: h => h(App),
    data: {
      jsonStepsData
    }
  }).$mount(querySelector);

  vm.$store.dispatch("initData", { vm });
};

if (document.getElementById("standaloneCalculatorApp")) {
  window.calculatorApp("#standaloneCalculatorApp", steps);
}
